import { render } from "./RadialTeamPerformanceGoal.vue?vue&type=template&id=49a5801c&scoped=true&lang=true"
import script from "./RadialTeamPerformanceGoal.vue?vue&type=script&lang=js"
export * from "./RadialTeamPerformanceGoal.vue?vue&type=script&lang=js"

import "./RadialTeamPerformanceGoal.vue?vue&type=style&index=0&id=49a5801c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-49a5801c"

export default script